export enum NextPageSetting {
  GoToNextCase = 'go-to-next-case',
  GoToCasesHome = 'go-to-cases-home',
  StayOnCurrentCase = 'stay-on-current-case',
}

export const NextPageSettingOptions = [
  {
    label: 'Automatically go to next assigned case',
    value: NextPageSetting.GoToNextCase,
  },
  {
    label: 'Automatically go to cases home',
    value: NextPageSetting.GoToCasesHome,
  },
  {
    label: 'Stay on current case',
    value: NextPageSetting.StayOnCurrentCase,
  },
];
